<template>
  <div>
    <v-form ref="modelObjForm">
      <v-data-table :headers="headers" :items="usersList" :loading="loading" item-key="id" dense :footer-props="paginationList" class="bordered--table pa-2 mt-8">
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item, index) in items" :key="item.id">
            <td>{{ item.name }}</td>
            <td>{{ item.email }}</td>
            <td>
              <v-text-field class="custom-padding ma-0" dense hide-details v-model="item.cost" @change="updateCost(item, index)" :rules="$_norwegianNumberValidation" @click="oldCostValue = item.cost"></v-text-field>
            </td>
            <td>
              <v-simple-checkbox :ripple="false" color="primary" v-model="item.can_deliver_hours" @input="updateDeliverPermission(item, index)"></v-simple-checkbox>
            </td>
            <td>
              <v-menu :close-on-content-click="false" offset-y @mouseout="test()">
                <template v-slot:activator="{ on }">
                  <v-chip small :color="item.color || '#7CB5EC'" v-on="on" :text-color="$format.foreGroundColor(item.color || '#7CB5EC')" @click="setColor = item.color || '#7CB5EC'">{{item.color || '#7CB5EC'}}</v-chip>
                </template>
                <v-color-picker v-model="setColor" class="mx-auto" mode="hexa" hide-mode-switch @input="setColorForItem(item, index)"></v-color-picker>
                </v-menu>
              <!-- <v-menu bottom :close-on-content-click="false" offset-y v-model="item.colorMenu">
                <template v-slot:activator="{ on }">
                  <v-text-field hide-details dense v-model="item.color" class="ma-0 pa-0" readonly slot="activator" v-on="on"></v-text-field>
                </template>
                <v-color-picker v-if="item.colorMenu" v-model="item.color" bottom flat />
              </v-menu> -->
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    </v-form>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dialog: false,
      modelObj: {},
      usersList: [],
      paginationList: {
        'itemsPerPageOptions': [10, 25, 50, 100, -1]
      },
      total: 0,
      loading: false,
      MODULE: 'users',
      oldCostValue: 0,
      oldDeliverPermission: null,
      setColor: ''
    }
  },
  computed: {
    headers () {
      return [{
        text: this.$t('message.layout.user'),
        value: 'name',
        isRoute: true,
        isModal: true,
        width: '25%'
      }, {
        text: this.$t('message.common.email'),
        value: 'email',
        width: '25%'
      }, {
        text: this.$t('message.common.cost'),
        value: 'cost',
        width: '15%'
      }, {
        text: this.$t('message.common.canDeliverHours'),
        value: 'can_deliver_hours',
        width: '15%'
      }, {
        text: this.$t('message.common.color'),
        value: 'color',
        width: '20%'
      }]
    }
  },
  mounted () {
    this.getListHandler()
  },
  methods: {
    setColorForItem (item, index) {
      item.color = this.setColor
      this.$set(this.usersList, index, item)
      this.updateColor(item)
    },
    getListHandler () {
      this.loading = true
      this.$api.execute('get', `${this.MODULE}`)
        .then((response) => {
          this.usersList = response.data
          this.loading = false
        })
    },
    updateCost (item, index) {
      if (this.$refs.modelObjForm.validate()) {
        let items = [item]
        this.$api.execute('post', `${this.MODULE}/update_cost`, items)
          .then((response) => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
            this.getListHandler()
          })
      } else {
        this.usersList[index].cost = this.oldCostValue
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: `Enter only numbers` })
      }
    },
    updateDeliverPermission (item, index) {
      this.$api.execute('put', `${this.MODULE}/${item.id}`, item)
        .then((response) => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
          this.getListHandler()
        })
    },
    updateColor (item) {
      this.$api.execute('put', `${this.MODULE}/${item.id}`, item)
        .then((response) => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
          this.getListHandler()
        })
    }
  }
}
</script>
<style>
.custom-padding input {
  padding: 0 !important;
}
.custom-padding {
  border-color: white !important;
}
/* .custom-padding .v-text-field__slot input {
  border: none;
} */
</style>
